var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionStateChanged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4046 3.57812C15.8982 3.57812 15.4876 3.98867 15.4876 4.4951V7.55587H12.3922C11.8858 7.55587 11.4752 7.9664 11.4752 8.47283V11.6662H8.37981C7.87339 11.6662 7.46285 12.0767 7.46285 12.5832V15.5776H4.41696C3.91054 15.5776 3.5 15.9882 3.5 16.4946V19.5058C3.5 20.0122 3.91054 20.4228 4.41696 20.4228H19.583C20.0895 20.4228 20.5 20.0122 20.5 19.5058V4.4951C20.5 3.98867 20.0895 3.57812 19.583 3.57812H16.4046Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionStateChanged);
export default __webpack_public_path__ + "static/media/TRANSACTION_STATE_CHANGED.024c6198b5a9c282bbe709a1a3def004.svg";
export { ForwardRef as ReactComponent };